import React, { useEffect, useState } from "react";
var viewHeight;
var itemsLength;
var scrollContainer;
var VIRTUAL_SCROLL_PLACEHOLDER = 'virtual-scroll-placeholder';
;
export var VirtualScroll = function (_a) {
    var parent = _a.parent, itemHeight = _a.itemHeight, rows = _a.rows, render = _a.render;
    var _b = useState(0), startIndex = _b[0], setStartIndex = _b[1];
    // constructor
    useEffect(function () {
        window.addEventListener('resize', onResize);
    }, []);
    useEffect(function () {
        if (!!rows.length) {
            setViewPort();
            scrollHandler();
        }
    }, [rows]);
    var onResize = function (e) {
        setViewPort();
    };
    var setViewPort = function () {
        scrollContainer = document.querySelector(parent);
        var virtualPlaceholder = document.querySelector('.' + VIRTUAL_SCROLL_PLACEHOLDER);
        if (scrollContainer) {
            scrollContainer.style.position = 'relative';
            viewHeight = scrollContainer.offsetHeight;
            // adds one extra item to cover the vblacnk space
            itemsLength = Math.ceil(viewHeight / itemHeight) + 1;
        }
        // updating the scroll height of the virtual container in case if the data is updated
        if (virtualPlaceholder) {
            var containerHeight = itemHeight * rows.length;
            virtualPlaceholder.style.height = containerHeight + 'px';
        }
        // creates only one virtual placeholder (in case if it is not there already)
        if (!virtualPlaceholder) {
            var containerHeight = itemHeight * rows.length;
            var placeholder = document.createElement('div');
            placeholder.className = VIRTUAL_SCROLL_PLACEHOLDER;
            placeholder.style.height = containerHeight + 'px';
            placeholder.style.width = '1px'; // fixes issues with firefox
            if (scrollContainer) {
                scrollContainer.appendChild(placeholder);
            }
        }
    };
    var scrollHandler = function () {
        scrollContainer = document.querySelector(parent);
        if (scrollContainer) {
            scrollContainer.addEventListener('scroll', function (e) {
                var sIndex = Math.floor(scrollContainer.scrollTop / itemHeight);
                setStartIndex(sIndex);
            });
        }
    };
    return (React.createElement(React.Fragment, null, rows.slice(startIndex, startIndex + itemsLength).map(function (r, i) {
        var index = startIndex + i;
        var top = itemHeight * index;
        return render({
            index: index,
            style: { position: 'absolute', top: top + 'px' }
        });
    })));
};
